import Vue from 'vue'
import ShowForm from './ShowForm'
import EditForm from './EditForm'

Vue.component('CarShowForm', ShowForm)
Vue.component('CarEditForm', EditForm)
